const buttonsPanelModifier = 'compact-in-column';
const jsButtonsPanel = `.buttons-panel--${buttonsPanelModifier}`;
const $jsButtonsPanel = $(jsButtonsPanel);

import {toggleList, hideList, showList, showAndHideByTab, sortTourSteps} from '../functions.js';

if ($jsButtonsPanel.length) {
	const config = require('./config.yaml');
	const jsShare = `${jsButtonsPanel} .js-share`, // js-share element for 'compact-in-column' template
		jsShareList = `${jsButtonsPanel} .js-share-list`, // js-share-list element for 'compact-in-column' template
		jsButtonsTrigger = `${jsButtonsPanel} .js-buttons-trigger`, // js-buttons-trigger element for 'compact-in-column' template
		jsSocial = `${jsButtonsPanel} .js-social`,
		jsSocialList = `${jsButtonsPanel} .js-social-list`,
		jsSubListsTrigger = `${jsButtonsPanel} .js-sublist-trigger`,
		jsSubLists = `${jsButtonsPanel} .js-sublist`,
		jsCompare = `${jsButtonsPanel} .js-compare`,
		jsCompareList = `${jsButtonsPanel} .js-compare-list`,
		$jsButtonsList = $(`${jsButtonsPanel} .js-buttons-list`),
		$jsShare = $(jsShare),
		$jsShareList = $(jsShareList),
		$jsSocial = $(jsSocial),
		$jsSocialList = $(jsSocialList),
		$jsButtonsTrigger = $(jsButtonsTrigger),
		$jsSubListsTrigger = $(jsSubListsTrigger),
		$jsSubLists = $(jsSubLists),
		$jsCompare = $(jsCompare),
		$jsCompareList = $(jsCompareList);
	var showEffect;
	var hideEffect;
	var sublistShowEffect;
	var sublistHideEffect;
	var tour = '';

	if (config.tools.showTour) {
		const tourConfig = require('../tourConfig.js')();
		const sorting = config.tools.sorting[templateVars.lang];
		var tourSteps = tourConfig.steps;
		tourSteps = sortTourSteps(tourSteps, sorting);
		tourSteps[0].delay = '100';
		tourConfig.id += buttonsPanelModifier;
		const Tour = require('component/tour/index.js');

		tourSteps.forEach(step => {
			step.target = `${jsButtonsPanel} ${step.target}`;
		});

		tour = new Tour(tourConfig);
	}

	if ($jsButtonsPanel.data('slideType') === 'vertical') {
		showEffect = 'transition.slideDownIn';
		hideEffect = 'transition.slideUpOut';
	} else {
		showEffect = 'transition.slideRightIn';
		hideEffect = 'transition.slideRightOut';
	}

	if ($jsSubLists.data('sublistSlideType') === 'left') {
		sublistShowEffect = 'transition.slideRightIn';
		sublistHideEffect = 'transition.slideRightOut';
	} else if ($jsSubLists.data('sublistSlideType') === 'right') {
		sublistShowEffect = 'transition.slideLeftIn';
		sublistHideEffect = 'transition.slideLeftOut';
	} else {
		$jsSubLists.attr('data-sublist-slide-type', 'bottom');
		sublistShowEffect = 'slideDown';
		sublistHideEffect = 'slideUp';
	}

	//Параметры анимации
	const sublistOptions = {
		showEffect: sublistShowEffect,
		hideEffect: sublistHideEffect,
		durationEffect: 200
	};

	const toolListOptions = {
		showEffect: showEffect,
		hideEffect: hideEffect,
		durationEffect: 200
	};

	// Селекторы элементов, клик по которым не закрывается панель
	const tourSelector = [`.tour-tools--${buttonsPanelModifier}`, '.hopscotch-nav-button'].join(', ');
	var dontCollapseSelectors = [jsCompare, jsShare, jsButtonsTrigger, '.js-add-page', '.js-del-page', '.js-no-collapse'];

	if (config.hoverablePanel) {
		var panelOpenEvents = 'touchstart mouseenter';
		var panelHideEvents = 'mouseover touchstart';
		dontCollapseSelectors.push(jsButtonsPanel);
	} else {
		var panelOpenEvents = 'click touchstart';
		var panelHideEvents = 'click touchstart';
	}

	if (config.hoverableSublist) {
		var sublistOpenEvents = 'touchstart mouseenter';
		var sublistHideEvents = 'mouseover touchstart';
	} else {
		var sublistOpenEvents = 'click touchstart';
		var sublistHideEvents = 'click touchstart';
	}

	const dontCollapseSelector = dontCollapseSelectors.join(', ');

	//Показать и скрыть панель по табу
	showAndHideByTab($jsButtonsTrigger, toolListOptions, $jsButtonsList);

	if ($jsCompare.length) {
		$jsCompareList.insertAfter(jsCompare);
	}

	function triggerAction(elem, list, options, hoverable) {
		if (hoverable) {
			if (!list.hasClass('is-expand')) {
				showList(elem, options);
			}
		} else {
			toggleList(elem, options, list);
		}
	}

	//Обработка событий
	$jsSubListsTrigger.on(sublistOpenEvents, function (event) {
		const $this = $(this);

		if ($this.data('list') !== undefined || !$this.hasClass('js-compare')) {
			event.preventDefault();
			const $currentList = $this.siblings('.js-list');
			const $expandedSublists = $this
				.closest('.buttons-panel__item')
				.siblings()
				.find('.js-sublist.is-expand');

			if ($expandedSublists.length) {
				hideList($expandedSublists.siblings('.js-sublist-trigger'), sublistOptions, $expandedSublists);
			}

			triggerAction($this, $currentList, sublistOptions, config.hoverableSublist);
		}
	});

	$jsButtonsTrigger.on(panelOpenEvents, function (event) {
		event.preventDefault();
		const $this = $(this);
		triggerAction($this, $jsButtonsList, toolListOptions, config.hoverablePanel);

		if (config.tools.showTour && !tour.checkCookie() && $this.closest('.buttons-panel--tools')) {
			tour.startFirstTime();
		}
	});

	function checkAndHideSubLists(event) {
		if (!$(event.target).closest(`${jsSubListsTrigger},${jsSubLists}`).length && $jsSubLists.hasClass('is-expand')) {
			hideList($jsSubListsTrigger, sublistOptions, $jsSubLists);
		}
	}

	$(document).on(sublistHideEvents, function (event) {
		checkAndHideSubLists(event);
	});

	$(document).on(panelHideEvents, function (event) {
		if (((event.type !== 'touchstart' && !$(event.target).closest(`${dontCollapseSelector},${tourSelector}`).length) ||
			(event.type === 'touchstart' && !$(event.target).closest(`${jsButtonsPanel},${tourSelector}`).length)) &&
			$jsButtonsList.hasClass('is-expand')) {
			if ($(`.tour-tools--${buttonsPanelModifier}`).length) {
				$(`.tour-tools--${buttonsPanelModifier}`).remove();
			}

			if (config.hoverablePanel && !config.hoverableSublist) {
				checkAndHideSubLists(event);
			}

			hideList($jsButtonsTrigger, toolListOptions, $jsButtonsList);
		}
	});
}



// WEBPACK FOOTER //
// ./temp/components/buttons-panel/compact-in-column/index.js